import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    totalList: '/wbs/total-task-list',
    taskList: '/wbs/task-list',
    getTaskSubmissionById: '/wbs/task-submission',
    getTaskApprovalById: '/wbs/task-approval',
    approve: '/wbs/task-approval-approve',
    getTimeUnit: '/wbs/time-unit',
    getWorkCalendarTimeUnit: '/wbs/work-calendar-and-time-unit',
    saveDraft: '/wbs/task-submission-save',
    submit: '/wbs/task-submission-submit',
    getTaskReviewById: '/wbs/task-review',
    saveReviewDraft: '/wbs/task-review-save',
    submitReview: '/wbs/task-review-submit',
    NeedToRevise: '/wbs/task-approval-revise',
    
}

const useWBSRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getWBSTotalList = async (payload) => {
        return await executeApi(REPO_URL.totalList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    
    const getWBSTaskList = async (payload) => {
        return await executeApi(REPO_URL.taskList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getTaskSubmissionById = async (payload) => {
        return await executeApi(REPO_URL.getTaskSubmissionById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getTaskApprovalById = async (payload) => {
        return await executeApi(REPO_URL.getTaskApprovalById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getTaskReviewById = async (payload) => {
        return await executeApi(REPO_URL.getTaskReviewById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const saveReviewDraft = async (payload) => {
        return await executeApi(REPO_URL.saveReviewDraft, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const submitReviewDraft = async (payload) => {
        return await executeApi(REPO_URL.submitReview, BASE_API_CONSTANT.METHOD.POST, payload)
    }


     const getWBSTimeUnit = async (payload) => {
        return await executeApi(REPO_URL.getTimeUnit, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const saveDraft = async (payload) => {
        return await executeApi(REPO_URL.saveDraft, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const submit = async (payload) => {
        return await executeApi(REPO_URL.submit, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const approve = async (payload) => {
        return await executeApi(REPO_URL.approve, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const needToRevise = async (payload) => {
        return await executeApi(REPO_URL.NeedToRevise, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getWorkCalendarTimeUnit = async (payload) => {
        return await executeApi(REPO_URL.getWorkCalendarTimeUnit, BASE_API_CONSTANT.METHOD.POST, payload)
    }


    return {
        isLoading,
        data,
        error,
        getWBSTotalList,
        getWBSTaskList,
        getTaskSubmissionById,
        getTaskApprovalById,
        getWBSTimeUnit,
        saveDraft,
        submit,
        approve,
        getTaskReviewById,
        saveReviewDraft,
        submitReviewDraft,
        needToRevise,
        getWorkCalendarTimeUnit
        // updateDivision,
        // deleteDivision
    }
}

export default useWBSRepo
